<template>
  <div class="teaching-score-grade-input-convert">
    <el-input-number v-model.number="current.convert"
                     :class="{'is-error': isError}"
                     size="mini"
                     controls-position="right"
                     :precision="1"
                     :step="1"
                     :min="getMin"
                     :max="getMax"
                     v-bind="$attrs"></el-input-number>
  </div>
</template>

<script>
export default {
  name: 'TeachingScoreGradeInputConvert',
  props: {
    current: {
      type: Object,
      required: true
    },
    next: Object,
    maxScore: Number,
    minScore: Number
  },
  computed: {
    fromMaximum () {
      if (this.next) {
        return this.next.maximum
      } else {
        return this.minScore
      }
    },
    toMaximum () {
      return this.current.maximum
    },
    getMin () {
      return this.fromMaximum
    },
    getMax () {
      const toMaximum = this.toMaximum
      if (typeof toMaximum === 'number') {
        if (this.current.includeMax) {
          return toMaximum
        } else {
          return toMaximum - 0.1
        }
      }
    },
    isError () {
      const getMin = this.getMin
      const getMax = this.getMax
      const getConvert = this.current.convert
      if (typeof getMin === 'number' && typeof getMax === 'number' && typeof getConvert === 'number') {
        if (getMin > getMax || getConvert < getMin || getConvert > getMax) {
          return true
        }
      }
    }
  },
  watch: {
    isError: {
      handler (val) {
        this.$set(this.current, '$convertError', val)
      },
      immediate: true
    }
  }
}
</script>
